const React = require("react");
const { NavLink, Outlet } = require("react-router-dom");
const { useInventorySource } = require("../context/InventorySourceContext");
const { getInventorySourceNavigation } = require("../navigation");
const { INVENTORY_SOURCE_CSS } = require("../styles");
const h = React.createElement;

const InventorySourceLayout = () => {
  const { t, isAdmin } = useInventorySource();
  return h("div", { className: "isds-shell" }, h("style", null, INVENTORY_SOURCE_CSS),
    h("header", { className: "isds-top" }, h("h1", null, t("h_inventorySource_title", "InventorySource Dropshipping")), h("p", null, t("h_inventorySource_subtitle", "Connect suppliers, import products and keep your Elakay catalog synchronized."))),
    h("nav", { className: "isds-nav", "aria-label": t("h_inventorySource_navigation", "InventorySource navigation") }, ...getInventorySourceNavigation(t, { isAdmin }).map((item) => h(NavLink, { key: item.to, to: item.to, className: ({ isActive }) => isActive ? "active" : "" }, item.label))),
    h("main", { className: "isds-main" }, h(Outlet))
  );
};
module.exports = { InventorySourceLayout };
